import service from '@/middleware'

const activityApi = {

    /**
     * Obtener las actividades de una empresa
     */
    async getAllByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/activity/enterprise/${enterpriseId}`)
        return result
    },

    /**
     * Obtener las actividades de una empresa y un tipo de equipo
     */
    async getAllByEnterpriseIdAndTypeId (enterpriseId, typeId) {
        const result = await service.http.get(`/api/activity/enterprise/${enterpriseId}/type/${typeId}`)
        return result
    },

    /**
     * Obtener las actividades de una empresa, sector y tipo de equipo en particular
     */
    async getAllByEnterpriseIdSectorIdAndTypeId (enterpriseId, sectorId, typeId) {
        const result = await service.http.get(`/api/activity/enterprise/${enterpriseId}/sector/${sectorId}/type/${typeId}`)
        return result
    },

}

export default activityApi
